import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import InputField from '../inputField';
import Icon from '../../elementals/icon';
import classnames from 'classnames/bind';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const FONT_LINK_ID = 'corinthia-google-font';
const SignatureInputField = props => {
    const { className, ...rest } = props;
    useEffect(() => {
        if (!document.getElementById(FONT_LINK_ID)) {
            const link = document.createElement('link');
            link.id = FONT_LINK_ID;
            link.rel = 'stylesheet';
            link.href =
                'https://fonts.googleapis.com/css2?family=Corinthia:wght@400;700&display=swap';
            document.head.appendChild(link);
        }
    }, []);
    return (_jsxs(InputField, { ...rest, className: cx('signature-field', className), children: [_jsx(Icon, { name: 'xmark', iconStyle: 'solid', size: 'small', color: 'grayMedium', className: cx('x-icon') }, 'icon'), _jsxs("div", { className: cx('input-wrapper'), children: [_jsx("div", { className: cx('underline') }), _jsx("input", { "aria-label": `${rest.elmId}_input` })] }, 'input-wrapper')] }));
};
export default SignatureInputField;
//# sourceMappingURL=index.js.map